module.exports = __webpack_public_path__ + "static/media/IMG_2201.b36a2a44.jpg";